// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

import * as ActiveStorage from "@rails/activestorage"
import "@rails/actiontext"
import "@37signals/lexxy"

// Import Bootstrap JS
import "bootstrap"

ActiveStorage.start()

const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)")

if ("startViewTransition" in document && !prefersReducedMotion.matches) {
  addEventListener("turbo:before-render", (event) => {
    if (prefersReducedMotion.matches) return

    event.preventDefault()
    const { resume } = event.detail

    document.startViewTransition(() => {
      resume()
    })
  })
}
